// extracted by mini-css-extract-plugin
module.exports = {"about":"about-module--about--1wsIb","bio":"about-module--bio--3esWZ","photo":"about-module--photo--1DQkw"};